import Rete from 'rete';

import VueResultControl from '../../components/commons/VueResultControl';


export default class DistPreviewControl extends Rete.Control {

	constructor(emitter, key, readonly, nodeID) { 
		super(key);
		this.data.render = 'vue';
		this.component = VueResultControl;
		this.props = { emitter, ikey: key, readonly, nodeID: nodeID};
	}

	setValue(val) {
		// This function just sends the values to the VueResultControl and writes it into the arrayvalues
		this.vueContext.value = val; // vueContext and
    this.update() // update() will be added after mounting of the component
	}
	
}
